import { formatDayMonth } from '@/shared/lib';
import { parsePlainDate, parsePlainDateTime } from '@shared/lib/date-time';

/** `Hour` — бакет `YYYY-MM-DDTHH:00`, остальные — дата начала окна `YYYY-MM-DD`. */
export type ChartGranularity = 'Hour' | 'Day' | 'Week' | 'Month';

/** Точка ряда; `incomplete` — период ещё идёт или наблюдение не закрыто, точка приглушена. */
export interface ChartPoint {
  date: string;
  value: number;
  incomplete?: boolean;
}

const formatChartDateLabel = (date: string): string => {
  const parsed = parsePlainDate(date);

  return parsed ? parsed.toLocaleString('ru-RU', { day: 'numeric', month: 'long' }) : formatDayMonth(date);
};

const formatHour = (hour: number): string => `${String(hour % 24).padStart(2, '0')}:00`;

export const formatChartAxisLabel = (date: string, granularity: ChartGranularity): string => {
  if (granularity === 'Hour') {
    const parsed = parsePlainDateTime(date);

    return parsed ? formatHour(parsed.hour) : date;
  }

  if (granularity !== 'Month') {
    return formatDayMonth(date);
  }

  const parsed = parsePlainDate(date);

  return parsed
    ? `${parsed.toLocaleString('ru-RU', { month: 'short' })} ${String(parsed.year).slice(-2)}`
    : formatDayMonth(date);
};

export const formatChartPointWindow = (date: string, granularity: ChartGranularity): string => {
  if (granularity === 'Hour') {
    const parsed = parsePlainDateTime(date);

    return parsed
      ? `${formatChartDateLabel(parsed.toPlainDate().toString())}, ${formatHour(parsed.hour)}–${formatHour(parsed.hour + 1)}`
      : date;
  }

  if (granularity === 'Day') {
    return formatChartDateLabel(date);
  }

  const start = parsePlainDate(date);

  if (!start) {
    return formatDayMonth(date);
  }

  if (granularity === 'Month') {
    return `${start.toLocaleString('ru-RU', { month: 'long' })} ${start.year}`;
  }

  const end = start.add({ days: 6 });

  return start.month === end.month
    ? `${start.day}–${end.day} ${end.toLocaleString('ru-RU', { day: 'numeric', month: 'long' }).replace(/^\d+\s/, '')}`
    : `${start.toLocaleString('ru-RU', { day: 'numeric', month: 'long' })} – ${end.toLocaleString('ru-RU', { day: 'numeric', month: 'long' })}`;
};
